<template>
  <div class="w_1200 m_lr_auto m_t_60">
    <div class="f_w_700 f_s_32 p_b_10">Update</div>
  </div>
</template>

<script>
/**
 * 产品参数
 */
export default {
  name: "OverView",
  props: {
    overview: {
      type: Object,Array,
      default: () => {
        return new Object({
        details: []
      })
      }
    }
  }
};
</script>

<style>
.w_266 {
  width: 290px;
}
</style>